import React from "react";
import styled from "styled-components";
import monoBankImage from "../../assets/discord.svg";
import theme from "../../styles/theme";
import { axiosInstance } from "../../utils/axios";

const LoginButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  border-radius: 4px;
  background: none;
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
  border: 1px solid ${theme.colors.grey};
  transition: all 0.1s linear;
  text-decoration: none;

  &:hover {
    background-color: #123753;
  }

  &:focus {
    outline: none;
  }
`;

const StyledSpan = styled.div`
  color: ${theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
`;

const DiscordImage = styled.img`
  width: 22px;
  filter: brightness(0) invert(1);
`;

const LoginWithDiscordButton = ({ mobile = false }) => {
  const handleLogin = async () => {
    try {
      const response = await axiosInstance.get("/auth/discord/url");
      if (response.data && response.data.url) {
        window.location.href = response.data.url;
      }
    } catch (error) {
      console.error("Failed to get Discord auth URL:", error);
    }
  };

  return (
    <LoginButton onClick={handleLogin}>
      <StyledSpan style={{ textDecoration: "none" }}>
        <DiscordImage src={monoBankImage}></DiscordImage>{" "}
        {mobile ? "Увійти" : "Увійти через Discord"}
      </StyledSpan>
    </LoginButton>
  );
};

export default LoginWithDiscordButton;
